import { environment } from "../../config/environment";
import { fetchJson } from "../../../fetch";

import AuthService from "../AuthService";
import {
  ScoreGroupedByUserModel,
  ScoreGroupedByDateModel,
  FriendUserInfo,
} from "../../models/FriendModel";
import { InviteInfo } from "../../models/InviteInfo";

const API_PATH = environment.FRIEND_API;
/* eslint-disable no-plusplus */

class FriendApiService {
    public async getInviteGuid(): Promise<string> {
        return await AuthService.authFetch(`${API_PATH}/friend/invite/create/`, { method: 'POST', body: '' });
    }

    public async getInviteInfo(guid: string): Promise<InviteInfo>{
        return await fetchJson(`${API_PATH}/friend/invite/${guid}`)
    }

    public async acceptInvite(guid: string): Promise<InviteInfo>{
        return await AuthService.authFetch(`${API_PATH}/friend/invite/accept/${guid}`, { method: 'POST', body: '' });
    }

    public async DeleteFriend(userId: string) {
        return await AuthService.authFetch(`${API_PATH}/friend/${userId}`, { method: 'DELETE'}, false);
    }

    public async getFriendList(): Promise<FriendUserInfo[]>{
        return await AuthService.authFetch(`${API_PATH}/friend/`, { method: 'GET'});
    }

    public async getFriendLeaderboardGroupByUser(slug: string, seeAll: boolean): Promise<ScoreGroupedByUserModel[]> {
        return await AuthService.authFetch(`${API_PATH}/score/friend/${slug}/group-by-user/${seeAll}`, { method: 'GET'});
    }

    public async getFriendLeaderboardGroupByDate(slug: string, seeAll: boolean): Promise<ScoreGroupedByDateModel[]>{
        return await AuthService.authFetch(`${API_PATH}/score/friend/${slug}/group-by-date/${seeAll}`, { method: 'GET'});
    }

    //TO DO 
    public async saveScoreByPuzzle(puzzleDate: string, puzzleId: string, slug: string, value: number): Promise<InviteInfo>{
        let body = JSON.stringify({ "puzzleDate" : puzzleDate, "puzzleId" : puzzleId, "value" : value, "slug" : slug});
        return await AuthService.authFetch(`${API_PATH}/score/save-score-by-puzzle/`, { method: 'POST', body: body });
    }
}
    
export default new FriendApiService();
